import { makeStyles } from '@mui/styles';
const specificationSelectorStyles = makeStyles(() => ({
    checkboxOption: {},
    checkboxOptionSelected: {},
    checkboxLabel: {},
    specSelector: {},
    radioOption: {},
    radioOptionSelected: {},
}), { name: 'Cmn_SpecificationSelector' });
export default specificationSelectorStyles;
//# sourceMappingURL=specificationSelector.styles.js.map